export default __webpack_public_path__ + "static/media/IBMPlexSans-Light-Latin1.3304fa63.woff2";